import { DndContext } from "@dnd-kit/core";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { useState } from "react";
import {
  TicketManagerConfig,
  TicketSaveModal,
  useProjects,
  useSaveTicketProject,
} from "../../..";
import { Project } from "../../../../../js/parsegenerated";
import { KanbanContext } from "../../context/KanbanContext";
import { useDragHandler } from "../../hooks/useDragHandler";
import { DragHandlerData } from "../../types/Draggable";
import { KanbanColumn } from "../KanbanColumn";
import { KanbanLayout } from "../KanbanLayout";

type Props = {
  ticketManagerConfig?: TicketManagerConfig;
};

export const ProjectView = observer((props: Props) => {
  const kanbanManager = React.useContext(KanbanContext);
  const { projects } = useProjects();
  const saveProject = useSaveTicketProject();
  const [[saveModalOpen, saveModalProject], setTicketSaveModal] = useState<
    [boolean, Project]
  >([false, undefined]);

  const dragHandler = useDragHandler(handleMoveProject);

  async function handleMoveProject(data: DragHandlerData) {
    try {
      await saveProject(data.destination, data.ticketData.ticket.id);
      kanbanManager.reload(data.destination);
      kanbanManager.reload(data.origin);
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <div>
      <DndContext onDragEnd={dragHandler}>
        <KanbanLayout>
          {projects.map((proj: Project) => (
            <KanbanColumn
              key={proj.id}
              id={proj.id}
              title={proj.get("name")}
              ticketManagerConfig={{
                filters: {
                  project: {
                    attribute: "project",
                    value: proj.id,
                  },
                },
              }}
              openSaveModal={() => setTicketSaveModal([true, proj])}
            />
          ))}
        </KanbanLayout>
      </DndContext>
      <TicketSaveModal
        open={saveModalOpen}
        initialValues={{
          project: saveModalProject?.id,
        }}
        onSaveSuccess={() => {
          kanbanManager.reload();
        }}
        onClose={() => setTicketSaveModal([false, undefined])}
      />
    </div>
  );
});
